import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';
import { PAYMENT_THRESHOLD } from '../../../../constants';
import { PAYMENT_DELAY } from '../../../../constants/payment';

import {
    getPaidAmountFormatted,
    isCurrentOnGoingPayementRequest,
    getDateFormatted,
    isFetching
} from '../../../../services/account/paymentrequest/ongoing/selector';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import { InfoAccountComponent } from '../InfoAccountComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import PaymentRequestAreaComponent from './PaymentRequestAreaComponent';
import ButtonComponent from '../../../../components/button/ButtonComponent';
import { withLoadingCondition } from '../../../loading/withLoadingCondition';

class PaymentAreaComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showFormPaymentRequest: false };
    }

    renderGetCashbackButton = () => {
        const { i18n, isCurrentOnGoingPayementRequest, thresholdReached } = this.props;
        if (!isCurrentOnGoingPayementRequest) {
            return (
                <div>
                    <ButtonComponent
                        color="main"
                        disabled={!thresholdReached}
                        text={this.props.i18n.BUTTON_GET_GAIN}
                        onClick={this.handleActiveButtonClick}
                    />
                    {!thresholdReached && (
                        <React.Fragment>
                            <p className="message-seuil">
                                {this.props.i18n.TRESHOLD_MESSAGE} {PAYMENT_THRESHOLD}€.
                            </p>
                            <LocalizedNavLink
                                to={PATH.FAQ_PATH}
                                title={i18n.NEED_HELP}
                                name="paymentArea-toFaq">
                                {i18n.NEED_HELP}
                            </LocalizedNavLink>
                        </React.Fragment>
                    )}
                </div>
            );
        }
        return null;
    };

    renderCurrentPayment = () => {
        const {
            i18n,
            isCurrentOnGoingPayementRequest,
            paidAmountOnGoingPayementRequest,
            dateOnGoingPaymentRequest
        } = this.props;

        if (isCurrentOnGoingPayementRequest) {
            return (
                <div className="txtleft">
                    <h3>{i18n.PAYMENT_AREA}</h3>
                    <InfoAccountComponent>
                        {convertHtmlToReactDomWithParams(
                            i18n.PAYMENT_ONGOING_1,
                            paidAmountOnGoingPayementRequest,
                            `<span class="bold">${dateOnGoingPaymentRequest}</span>`
                        )}
                        <br />
                        {i18n.PAYMENT_ONGOING_2}
                    </InfoAccountComponent>
                </div>
            );
        }
        return null;
    };

    handleActiveButtonClick = () => {
        this.setState({
            showFormPaymentRequest: !this.state.showFormPaymentRequest
        });
    };

    renderPaymentRequestAreaComponent = () =>
        this.state.showFormPaymentRequest &&
        !this.props.isCurrentOnGoingPayementRequest && <PaymentRequestAreaComponent />;

    renderArea = () => (
        <div className="txtcenter-mob bt-recup-cagnotte">
            {this.renderCurrentPayment()}
            {this.renderGetCashbackButton()}
            <hr />
            {this.renderPaymentRequestAreaComponent()}
        </div>
    );

    render() {
        return (
            <div id="paymentAreaAnchor">
                {withLoadingCondition(this.props.isFetchingOnGoingPayment, this.renderArea)}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        paidAmountOnGoingPayementRequest: getPaidAmountFormatted(state),
        isCurrentOnGoingPayementRequest: isCurrentOnGoingPayementRequest(state),
        dateOnGoingPaymentRequest: getDateFormatted(state, PAYMENT_DELAY),
        isFetchingOnGoingPayment: isFetching(state)
    };
};

export default connect(mapStateToProps)(PaymentAreaComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentAreaComponent.js